export enum GMAIL_LABEL_IDS {
  UNREAD = 'UNREAD',
}

export enum SORT {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum APP_ORIGINS {
  WEB = 'WEB',
  BACKOFFICE = 'BACKOFFICE',
  MOBILE = 'MOBILE',
  TUTOR = 'TUTOR',
  OTHER = 'OTHER',
}

export const APP_ORIGIN_HEADER_KEY = 'APP-ORIGIN';

/** Sales channel a course is sold on, and a student account originates from. */
export enum SALES_CHANNELS {
  E_COMMERCE = 'E_COMMERCE',
  SALESFORCE = 'SALESFORCE',
}

/**
 * Backend capabilities a sales channel brings along. A channel only carries what the systems behind
 * it actually implement: everything CRM-backed belongs to Salesforce alone, since an e-commerce
 * account has no counterpart there.
 */
export enum SALES_CHANNEL_CAPABILITIES {
  CRM_EXAM_REGISTRATION = 'CRM_EXAM_REGISTRATION',
  CRM_HISTORY_LOG = 'CRM_HISTORY_LOG',
  CRM_INTERNSHIP_CONTRACTS = 'CRM_INTERNSHIP_CONTRACTS',
  CRM_PAYMENT_LINK = 'CRM_PAYMENT_LINK',
  CRM_STUDENT_CARD = 'CRM_STUDENT_CARD',
  /** Administrative record held by the CRM: student profile and course registration. */
  CRM_STUDENT_RECORD = 'CRM_STUDENT_RECORD',
  /** Course access closed by the `students:access:end` cron. The e-commerce drives its own. */
  SCHEDULED_ACCESS_CLOSING = 'SCHEDULED_ACCESS_CLOSING',
}

/** Capabilities carried by each sales channel. Adding a channel means adding one entry here. */
export const SALES_CHANNEL_CONFIGS: Record<
  SALES_CHANNELS,
  { capabilities: SALES_CHANNEL_CAPABILITIES[] }
> = {
  [SALES_CHANNELS.E_COMMERCE]: {
    capabilities: [],
  },
  [SALES_CHANNELS.SALESFORCE]: {
    capabilities: Object.values(SALES_CHANNEL_CAPABILITIES),
  },
};
